export default {
  // Page
  采购订单记录: "采购订单记录",

  // FooterActions
  返回: "返回",

  // OrderInfoCard
  订单信息: "订单信息",
  订单状态: "订单状态",
  采购单号: "采购单号",
  需求人: "需求人",
  需求部门: "需求部门",
  PO创建时间: "PO创建时间",
  工厂: "工厂",
  物料类别: "物料类别",
  二级物料类别: "二级物料类别",

  // DeliveryTable
  交货次数: "交货次数",
  发货批次: "发货批次",
  发货数量: "发货数量",
  发货时间: "发货时间",
  收货数量: "收货数量",
  收货时间: "收货时间",
  交货明细: "交货明细",
  已发货数量: "已发货数量",
  已收货数量: "已收货数量",
  待发货数量: "待发货数量",

  // PurchaseInfoCard
  采购信息: "采购信息",
  物料类型: "物料类型",
  生产性物料: "生产性物料",
  非生产性物料: "非生产性物料",
  供应商编号: "供应商编号",
  供应商中文名称: "供应商中文名称",
  供应商英文名称: "供应商英文名称",
  采购组: "采购组",
  币种: "币种",
  汇率: "汇率",
  付款条约: "付款条约",
  国际贸易条款: "国际贸易条款",
  发货地址: "发货地址",
  发货联系人: "发货联系人",
  发货联系电话: "发货联系电话",

  // ProductInfoCard
  采购产品信息: "采购产品信息",
  项目号: "项目号",
  物料编号: "物料编号",
  物料组: "物料组",
  会计科目: "会计科目",
  PO数量: "PO数量",
  单位: "单位",
  价格: "价格",
  价格单位: "价格单位",
  原币金额: "原币金额",
  "本币金额（HKD）": "本币金额（HKD）",
  "收货本币金额（HKD）": "收货本币金额（HKD）",
  "发票已付本币金额（HKD）": "发票已付本币金额（HKD）",
  计划交货日期: "计划交货日期",
  库位: "库位",
  收货地址: "收货地址",
  收货联系人收货联系电话: "收货联系人/收货联系电话",

  // useOrderStatusOptions
  待发货: "待发货",
  已发货: "已发货",
  已部分收货: "已部分收货",
  已收货: "已收货",
  待收款: "待收款",
  已部分收款: "已部分收款",
  已收款: "已收款",

  // usePurchaseOrderRecordBehavior
  操作: "操作",
  查看: "查看",
  发货状态: "发货状态",
  付款状态: "付款状态",
  订单编号: "订单编号",
  PO编号: "PO编号",
  产品名称: "产品名称",
  供应商编码: "供应商编码",
  供应商: "供应商",
  金额: "金额",
  "收货联系人/收货联系电话": "收货联系人/收货联系电话",
  请输入物料编号或名称搜索: "请输入物料编号或名称搜索",
  请输入供应商编号或名称搜索: "请输入供应商编号或名称搜索",
};
